/*
 * Mangiobevo · Landing Panettoni Noël 2026
 * Motore della pagina (dalla versione v3 approvata) + collegamento al carrello Shopify.
 * Ogni sezione vive in uno Shadow DOM: la grafica non viene toccata dal CSS del tema.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* Collegamento Shopify                                                */
  /* ------------------------------------------------------------------ */
  function readJSON(id) {
    var el = document.getElementById(id);
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }

  function norm(s) {
    return String(s == null ? '' : s).normalize('NFC').toLowerCase().replace(/[’']/g, "'").replace(/\s+/g, ' ').trim();
  }

  function chf(cents) {
    if (cents == null) return null;
    var v = cents / 100;
    return Math.round(v) === v ? v : v.toFixed(2);
  }

  function makeBridge(cfg) {
    var T = function (L, key) { return (cfg.texts[L] || cfg.texts.FR)[key]; };

    function cartUrl() {
      var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
      return base.replace(/\.js$/, '') + '.js';
    }

    /* Numero di articoli nel carrello: serve per mostrare "Voir mon panier".
       Il cliente va al carrello quando ha finito: lì Zapiet chiede ritiro o consegna e la data. */
    var count = 0;
    function setCount(n) {
      count = n || 0;
      document.dispatchEvent(new CustomEvent('mb26:cart', { detail: { count: count } }));
    }
    function refreshCount() {
      var url = ((window.routes && window.routes.cart_url) || '/cart').replace(/\.js$/, '') + '.js';
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); }, function () {});
    }
    refreshCount();

    /* Aggiorna solo l'icona del carrello nell'header, senza aprire l'anteprima */
    function updateBubble(sections) {
      var html = sections && sections['cart-icon-bubble'], el = document.getElementById('cart-icon-bubble');
      if (!html || !el) return;
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      el.innerHTML = src ? src.innerHTML : html;
    }

    function postItems(items, L) {
      var body = { items: items, sections: ['cart-icon-bubble'], sections_url: window.location.pathname };
      return fetch(cartUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || j.status) throw new Error(j.description || j.message || T(L, 'error'));
          return j;
        });
      }, function () { throw new Error(T(L, 'error')); }).then(function (res) {
        try { updateBubble(res.sections); } catch (e) { /* il prodotto è comunque nel carrello */ }
        setCount(count + items.reduce(function (n, it) { return n + (it.quantity || 1); }, 0));
        refreshCount();
        document.dispatchEvent(new CustomEvent('mb26:added', { detail: res }));
        return res;
      });
    }

    function props(extra) {
      var p = {};
      if (cfg.preorder) p['_Précommande'] = cfg.preorder;
      return Object.assign(p, extra || {});
    }

    /* Conferma dei 18 anni (finestra nel documento, fuori dalle sezioni) */
    function confirmAge(L) {
      if (!cfg.ageConfirm) return Promise.resolve(false);
      return new Promise(function (resolve, reject) {
        var wrap = document.createElement('div');
        wrap.className = 'mb26-age';
        wrap.innerHTML =
          '<div class="mb26-age__box" role="dialog" aria-modal="true" aria-labelledby="mb26-age-t">' +
          '<p id="mb26-age-t"></p><div class="mb26-age__btns">' +
          '<button type="button" class="mb26-age__no"></button>' +
          '<button type="button" class="mb26-age__yes"></button></div></div>';
        wrap.querySelector('p').textContent = T(L, 'ageQ');
        wrap.querySelector('.mb26-age__no').textContent = T(L, 'ageNo');
        wrap.querySelector('.mb26-age__yes').textContent = T(L, 'ageYes');
        function close(ok) {
          document.removeEventListener('keydown', onKey);
          wrap.remove();
          if (ok) resolve(true); else reject({ cancelled: true });
        }
        function onKey(e) { if (e.key === 'Escape') close(false); }
        wrap.addEventListener('click', function (e) { if (e.target === wrap) close(false); });
        wrap.querySelector('.mb26-age__no').addEventListener('click', function () { close(false); });
        wrap.querySelector('.mb26-age__yes').addEventListener('click', function () { close(true); });
        document.addEventListener('keydown', onKey);
        document.body.appendChild(wrap);
        wrap.querySelector('.mb26-age__yes').focus();
      });
    }

    function coffretVariant(pick) {
      var cf = cfg.coffret;
      if (!cf || !cf.variants || !cf.variants.length) return null;
      var names = (cf.options || []).map(norm);
      function idx(re, fallback) {
        for (var i = 0; i < names.length; i++) if (re.test(names[i])) return i;
        return fallback;
      }
      var ip = idx(/panettone/, 0), ic = idx(/chocolat|cioccolat/, 1), iw = idx(/vin|wine|vino|spumante|bouteille|bottiglia/, 2);
      var want = {}; want[ip] = norm(pick.p); want[ic] = norm(pick.c); want[iw] = norm(pick.w);
      for (var v = 0; v < cf.variants.length; v++) {
        var o = cf.variants[v].o, ok = true;
        for (var k in want) if (norm(o[k]) !== want[k]) { ok = false; break; }
        if (ok) return cf.variants[v];
      }
      return null;
    }

    return {
      cartCount: function () { return count; },
      cartUrl: function () { return (window.routes && window.routes.cart_url) || '/cart'; },
      panettonePrice: function (i) {
        var p = (cfg.panettoni || [])[i];
        return p && p.price != null ? chf(p.price) : null;
      },
      coffretPrice: function (fallback) {
        var cf = cfg.coffret;
        return cf && cf.price != null ? chf(cf.price) : fallback;
      },
      addPanettone: function (i, q, L) {
        var p = (cfg.panettoni || [])[i];
        if (!p || !p.variant) return Promise.reject(new Error(T(L, 'missing')));
        return postItems([{ id: p.variant, quantity: q, properties: props() }], L);
      },
      addCoffret: function (pick, q, L) {
        if (!cfg.coffret) return Promise.reject(new Error(T(L, 'missing')));
        var v = coffretVariant(pick);
        if (!v) return Promise.reject(new Error(T(L, 'combo')));
        return confirmAge(L).then(function (asked) {
          var extra = asked ? { '_Âge 18+': T('FR', 'ageLog') } : {};
          return postItems([{ id: v.id, quantity: q, properties: props(extra) }], L);
        });
      }
    };
  }

  /* ------------------------------------------------------------------ */
  /* Motore delle sezioni (identico alla v3, adattato al tema)           */
  /* ------------------------------------------------------------------ */
  var HOLE = /\{\{\s*([^}]*?)\s*\}\}/g;
  function look(scope, path) {
    if (path === 'true') return true; if (path === 'false') return false;
    var v = scope; var parts = path.split('.');
    for (var i = 0; i < parts.length; i++) { if (v == null) return undefined; v = v[parts[i]]; }
    return v;
  }
  function str(v) { return v == null ? '' : String(v); }
  function interp(s, scope) { return s.replace(HOLE, function (m, p) { return str(look(scope, p)); }); }
  function single(s) { var m = /^\s*\{\{\s*([^}]*?)\s*\}\}\s*$/.exec(s); return m ? m[1] : null; }

  function append(out, n) { if (Array.isArray(out)) out.push(n); else out.appendChild(n); }

  function build(node, scope, out) {
    if (node.nodeType === 3) { append(out, document.createTextNode(interp(node.data, scope))); return; }
    if (node.nodeType !== 1) return;
    var tag = node.localName;
    if (tag === 'sc-for') {
      var list = look(scope, single(node.getAttribute('list')) || '') || [], as = node.getAttribute('as') || 'item';
      list.forEach(function (item, idx) {
        var sc = Object.create(scope); sc[as] = item; sc.$index = idx;
        node.childNodes.forEach(function (ch) { build(ch, sc, out); });
      });
      return;
    }
    if (tag === 'sc-if') {
      if (look(scope, single(node.getAttribute('value')) || '')) node.childNodes.forEach(function (ch) { build(ch, scope, out); });
      return;
    }
    var el = node.cloneNode(false); el.__ta = {}; el.__h = {};
    Array.prototype.slice.call(node.attributes).forEach(function (a) {
      if (a.name.indexOf('hint-') === 0) { el.removeAttribute(a.name); return; }
      var p = single(a.value);
      if (a.name.indexOf('on') === 0 && p) {
        el.removeAttribute(a.name); el.__h[a.name.slice(2)] = look(scope, p); return;
      }
      if (a.value.indexOf('{{') >= 0) {
        var v = p ? look(scope, p) : interp(a.value, scope);
        if (v === false || v == null) { v = p && a.name.indexOf('aria-') === 0 ? String(v) : null; }
        if (v === null) el.removeAttribute(a.name); else el.setAttribute(a.name, String(v));
      }
      el.__ta[a.name] = el.getAttribute(a.name);
    });
    var src = node.content ? node.content : node;
    src.childNodes.forEach(function (ch) { build(ch, scope, el); });
    append(out, el);
  }

  function bindEvents(el) {
    Object.keys(el.__h || {}).forEach(function (t) {
      if (!el.__bound) el.__bound = {};
      if (!el.__bound[t]) { el.__bound[t] = true; el.addEventListener(t, function (e) { var f = el.__h[t]; if (typeof f === 'function') f(e); }); }
    });
  }
  function adopt(n) { if (n.nodeType === 1) { bindEvents(n); n.querySelectorAll('*').forEach(bindEvents); } return n; }
  function patch(oldEl, newEl) {
    var nt = newEl.__ta || {}, ot = oldEl.__ta || {};
    Object.keys(ot).forEach(function (k) { if (!(k in nt)) oldEl.removeAttribute(k); });
    Object.keys(nt).forEach(function (k) {
      if (ot[k] !== nt[k]) { if (nt[k] === null) oldEl.removeAttribute(k); else oldEl.setAttribute(k, nt[k]); }
    });
    oldEl.__ta = nt; oldEl.__h = newEl.__h; bindEvents(oldEl);
    morph(oldEl, Array.prototype.slice.call(newEl.childNodes));
  }
  function morph(parent, nodes) {
    var olds = Array.prototype.slice.call(parent.childNodes).filter(function (n) { return n.nodeType === 1 || n.nodeType === 3; });
    for (var i = 0; i < nodes.length; i++) {
      var o = olds[i], n = nodes[i];
      if (!o) { parent.appendChild(adopt(n)); continue; }
      if (o.nodeType === 3 && n.nodeType === 3) { if (o.data !== n.data) o.data = n.data; continue; }
      if (o.nodeType === 1 && n.nodeType === 1 && o.localName === n.localName) { patch(o, n); continue; }
      parent.replaceChild(adopt(n), o);
    }
    for (var j = nodes.length; j < olds.length; j++) parent.removeChild(olds[j]);
  }

  function DCLogic() {}
  DCLogic.prototype.setState = function (p) {
    var prev = this.state || {};
    this.state = Object.assign({}, prev, typeof p === 'function' ? p(prev, this.props) : p);
    this.__update();
  };
  DCLogic.prototype.forceUpdate = function () { this.__update(); };

  /* Aggiornamento del 13.10.2026 (carta e coffret): "Ajouter au panier" al posto di
     "Précommander", nessuna anteprima del carrello, link "Voir mon panier".
     Si applica solo se i sorgenti contengono ancora i testi precedenti. */
  var CART_VALS = "cartOn: !!(window.MB26 && window.MB26.cartCount() > 0), cartUrl: window.MB26 ? window.MB26.cartUrl() : '/cart', " +
    "cartLbl: c.cart + (window.MB26 && window.MB26.cartCount() > 0 ? ' (' + window.MB26.cartCount() + ')' : ''), ";
  var CART_LINK = '<sc-if value="{{cartOn}}"><a class="tocart" href="{{cartUrl}}">{{cartLbl}} <em>→</em></a></sc-if>';
  var CART_CSS = '\n.tocart{display:inline-flex;align-items:center;gap:8px;align-self:flex-start;font:600 12px var(--f-body);letter-spacing:.1em;' +
    'text-transform:uppercase;color:var(--blue);text-decoration:none;border-bottom:1px solid currentColor;padding-bottom:3px;margin-top:2px}' +
    '\n.tocart em{font-style:normal;transition:transform .2s}.tocart:hover em{transform:translateX(4px)}\n';
  function rep(s, a, b) { return s.indexOf(a) >= 0 ? s.split(a).join(b) : s; }
  function upgrade(secs) {
    secs.forEach(function (s) {
      if (s.id === 'carte' && s.code.indexOf('cartOn:') < 0) {
        s.code = rep(s.code, 'pre: "Précommander", done: "Précommandé ✓"', 'pre: "Ajouter au panier", done: "Ajouté ✓", cart: "Voir mon panier"');
        s.code = rep(s.code, 'pre: "Pre-order", done: "Pre-ordered ✓"', 'pre: "Add to cart", done: "Added ✓", cart: "View my cart"');
        s.code = rep(s.code, 'added: "Précommande ajoutée : "', 'added: "Ajouté au panier : "');
        s.code = rep(s.code, 'added: "Pre-order added: "', 'added: "Added to cart: "');
        s.code = rep(s.code, 'return { c: c, rows: rows,', 'return { ' + CART_VALS + 'c: c, rows: rows,');
        s.tpl = rep(s.tpl, '<p class="{{pv.totCls}}">{{pv.totTxt}}</p>', '<p class="{{pv.totCls}}">{{pv.totTxt}}</p>\n        ' + CART_LINK);
        s.tpl = rep(s.tpl, '<p class="{{r.totCls}}">{{r.totTxt}}</p>', '<p class="{{r.totCls}}">{{r.totTxt}}</p>\n                ' + CART_LINK);
        s.css += CART_CSS;
      }
      if (s.id === 'coffret' && s.code.indexOf('cartOn:') < 0) {
        s.code = rep(s.code, 'added: "Précommande ajoutée : "', 'added: "Ajouté au panier : ", cart: "Voir mon panier"');
        s.code = rep(s.code, 'added: "Pre-order added: "', 'added: "Added to cart: ", cart: "View my cart"');
        s.code = rep(s.code, 'c: c, pSw:', CART_VALS + 'c: c, pSw:');
        s.tpl = rep(s.tpl, '<p class="legal">{{c.legal}}</p>', CART_LINK + '\n      <p class="legal">{{c.legal}}</p>');
        s.css += CART_CSS + '.coffret .tocart{margin:4px 0 14px}\n';
      }
    });
    return secs;
  }

  function mount(root) {
    if (!root || root.__mb26) return;
    var DATA = readJSON('mb26-data'), cfg = readJSON('mb26-config');
    if (!DATA || !cfg) return;
    upgrade(DATA.secs);
    root.__mb26 = true;
    window.MB26 = makeBridge(cfg);

    var base = cfg.assetBase || '';
    function fix(s) { return s.replace(/%%A%%/g, base); }

    var startLang = cfg.lang === 'EN' ? 'EN' : 'FR';
    var app = root.querySelector('.mb26-app');
    var comps = [];
    DATA.secs.forEach(function (s) {
      var host = document.createElement('div'); host.className = 'dc-host'; host.id = s.id;
      app.appendChild(host);
      var sroot = host.attachShadow({ mode: 'open' });
      var st = document.createElement('style'); st.textContent = fix(s.css); sroot.appendChild(st);
      var mnt = document.createElement('div'); mnt.className = 'dc-root'; sroot.appendChild(mnt);
      var tplEl = document.createElement('template'); tplEl.innerHTML = fix(s.tpl);
      var doc = new Proxy(document, { get: function (t, k) {
        if (k === 'getElementById') return function (id) { return sroot.getElementById(id); };
        if (k === 'querySelector') return function (q) { return sroot.querySelector(q); };
        if (k === 'querySelectorAll') return function (q) { return sroot.querySelectorAll(q); };
        var v = t[k]; return typeof v === 'function' ? v.bind(t) : v;
      } });
      var Cls = new Function('DCLogic', 'document', fix(s.code) + '\n;return Component;')(DCLogic, doc);
      var c = new Cls(); c.props = Object.assign({}, s.props, { langue: startLang }); c.__tpl = tplEl.content;
      var busy = false;
      c.__render = function () {
        var vals = c.renderVals ? c.renderVals() : {};
        var out = []; c.__tpl.childNodes.forEach(function (ch) { build(ch, vals, out); });
        morph(mnt, out);
      };
      c.__update = function () {
        if (busy) { c.__again = true; return; }
        busy = true; try { c.__render(); } finally { busy = false; }
        if (c.componentDidUpdate) c.componentDidUpdate();
        if (c.__again) { c.__again = false; c.__update(); }
      };
      c.__render(); comps.push(c);
    });
    comps.forEach(function (c) { if (c.componentDidMount) c.componentDidMount(); });
    function onCart() { comps.forEach(function (c) { c.__update(); }); }
    document.addEventListener('mb26:cart', onCart);

    /* lingua */
    var btns = root.querySelectorAll('.mb26-lang button');
    function setLang(l) {
      btns.forEach(function (x) { x.classList.toggle('on', x.getAttribute('data-l') === l); });
      root.setAttribute('lang', l.toLowerCase());
      comps.forEach(function (c) { c.props = Object.assign({}, c.props, { langue: l }); c.__update(); });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { setLang(b.getAttribute('data-l')); }); });
    if (startLang !== 'FR') setLang(startLang);

    /* barra mobile: dopo l'hero, nascosta sulla carta e in fondo */
    var bar = root.querySelector('#barre'), hero = root.querySelector('#hero'), carte = root.querySelector('#carte');
    function barUpd() {
      if (!bar || !hero || !carte) return;
      var h = hero.getBoundingClientRect(), c = carte.getBoundingClientRect();
      var end = scrollY + innerHeight > document.documentElement.scrollHeight - 200;
      var onCarte = c.top < innerHeight && c.bottom > 0;
      bar.classList.toggle('show', h.bottom < 0 && !onCarte && !end);
    }
    addEventListener('scroll', barUpd, { passive: true }); addEventListener('resize', barUpd); barUpd();

    root.__mb26stop = function () {
      comps.forEach(function (c) { try { if (c.componentWillUnmount) c.componentWillUnmount(); } catch (e) {} });
      removeEventListener('scroll', barUpd); removeEventListener('resize', barUpd);
      document.removeEventListener('mb26:cart', onCart);
    };
  }

  function start() { document.querySelectorAll('.mb26').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  /* editor del tema: la sezione viene ricaricata quando si cambiano le impostazioni */
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('.mb26');
    if (r && r.__mb26stop) r.__mb26stop();
  });
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('.mb26');
    if (r) mount(r);
  });
})();
